module.exports = __webpack_public_path__ + "img/mseicon.d277ef38.png";